"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.symbol = symbol;
function symbol() {
    // eslint-disable-next-line max-len,quotes
    return '<symbol viewbox="0 0 16 16" id=icon-location-16><path d="M10 7a2 2 0 1 1-4 0 2 2 0 0 1 4 0Z"></path><path fill-rule=evenodd clip-rule=evenodd d="M8 0a7 7 0 0 0-5.525 11.299c1.183 1.518 2.91 2.994 4.926 4.502a1 1 0 0 0 1.198 0c2.017-1.508 3.743-2.984 4.926-4.502A7 7 0 0 0 8 0ZM3 7a5 5 0 1 1 8.947 3.07c-.909 1.166-2.25 2.37-3.947 3.675-1.698-1.305-3.038-2.509-3.947-3.675A4.974 4.974 0 0 1 3 7Z"></path></symbol>';
}
